var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBellwhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 37,
    viewBox: "0 0 35 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5642 16.8148C28.5127 26.1418 32.6229 28.9874 32.6229 28.9874H1.16406C1.16406 28.9874 6.38088 25.3514 6.38088 12.2304C6.41685 9.32355 7.48092 6.52334 9.38447 4.32617C10.3279 3.29146 11.4747 2.46257 12.7532 1.89135C14.0316 1.32012 15.4142 1.01886 16.8144 1.0064C17.3985 0.980421 17.9835 1.0336 18.5533 1.16448",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8197 34.2051C19.4809 34.702 19.0519 35.1309 18.555 35.4698C18.0331 35.7919 17.4293 35.9566 16.8161 35.944C16.2029 35.9566 15.5991 35.7919 15.0772 35.4698C14.5803 35.131 14.1513 34.702 13.8125 34.2051",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.06653 16.8148C5.11803 26.1418 1.00781 28.9874 1.00781 28.9874H32.4667C32.4667 28.9874 27.2498 25.3514 27.2498 12.2304C27.2139 9.32355 26.1498 6.52334 24.2462 4.32617C23.3028 3.29146 22.1559 2.46257 20.8775 1.89135C19.599 1.32012 18.2165 1.01886 16.8163 1.0064C16.2321 0.980421 15.6472 1.0336 15.0774 1.16448",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellwhite);
export default __webpack_public_path__ + "static/media/bellwhite.88e217efe523d5adf2938ee6d1c577b0.svg";
export { ForwardRef as ReactComponent };